import * as THREE from 'three';

/** The coast's memorial mark: a diamond enclosing an unbroken circle, facing local +Z. */
export function memorialEmblem(material: THREE.Material, width: number, height: number, stroke = .022) {
  const outline = new THREE.Shape();
  outline.moveTo(0, height / 2); outline.lineTo(width / 2, 0); outline.lineTo(0, -height / 2); outline.lineTo(-width / 2, 0); outline.closePath();
  const inset = new THREE.Path(), innerWidth = width - stroke * 2.7, innerHeight = height - stroke * 2.7;
  inset.moveTo(0, innerHeight / 2); inset.lineTo(-innerWidth / 2, 0); inset.lineTo(0, -innerHeight / 2); inset.lineTo(innerWidth / 2, 0); inset.closePath(); outline.holes.push(inset);
  const group = new THREE.Group(); group.name = 'Diamond and circle memorial';
  const border = new THREE.Mesh(new THREE.ExtrudeGeometry(outline, { depth: .008, bevelEnabled: false }), material);
  const circle = new THREE.Mesh(new THREE.TorusGeometry(Math.min(innerWidth, innerHeight) * .23, stroke * .48, 5, 24), material); circle.position.z = .005;
  for (const part of [border, circle]) { part.castShadow = false; part.receiveShadow = true; group.add(part); }
  return group;
}
